import { Box, Container, Grid, Paper, Typography, Avatar } from '@mui/material';

export function FacultyPreview({ data }) {
  const primaryColor = data.primary_color || '#1e3a8a';
  const faculty = Array.isArray(data.faculty) ? data.faculty : [];

  if (faculty.length === 0) return null;

  return (
    <Box sx={{ py: { xs: 8, md: 10 }, backgroundColor: '#ffffff' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', maxWidth: 640, mx: 'auto', mb: 6 }}>
          <Box sx={{ display: 'inline-block', px: 2, py: 0.5, borderRadius: 4, backgroundColor: `${primaryColor}15`, color: primaryColor, mb: 1.5 }}>
            <Typography variant="caption" fontWeight={700} letterSpacing="0.05em">
              OUR EDUCATORS
            </Typography>
          </Box>
          <Typography variant="h2" fontWeight={800} color="#0f172a" sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, mb: 1 }}>
            Meet Our Leadership & Faculty
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Passionate educators committed to inspiring academic excellence and character growth.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {faculty.map((member, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  textAlign: 'center',
                  borderRadius: 4,
                  backgroundColor: '#f8fafc',
                  border: '1px solid #e2e8f0',
                  height: '100%',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: '#ffffff',
                    boxShadow: '0 15px 35px rgba(0,0,0,0.08)',
                    borderColor: primaryColor,
                  },
                }}
              >
                <Avatar
                  src={member.image}
                  alt={member.name}
                  sx={{
                    width: 80,
                    height: 80,
                    mx: 'auto',
                    mb: 2,
                    border: `3px solid ${primaryColor}`,
                    boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
                  }}
                />
                <Typography variant="h6" fontWeight={800} color="#0f172a" sx={{ fontSize: '1.05rem', mb: 0.5 }}>
                  {member.name}
                </Typography>
                <Typography variant="subtitle2" color={primaryColor} fontWeight={700} sx={{ mb: 1, fontSize: '0.875rem' }}>
                  {member.designation}
                </Typography>
                {member.qualification && (
                  <Typography variant="caption" color="text.secondary" fontWeight={500} display="block">
                    {member.qualification}
                  </Typography>
                )}
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default FacultyPreview;
